export const locale = Spree.url_params['locale'];
